import type React from 'react';

export interface CopyAnnouncerProps {
  message: string;
}

/** Visually hidden `aria-live` region; paired with `CopiedBadge` for copy feedback. */
const CopyAnnouncer = ({ message }: CopyAnnouncerProps): React.JSX.Element => (
  <span
    className="sr-only"
    role="status"
    aria-live="polite"
    aria-atomic="true"
    data-testid="message-copy-announcer"
  >
    {message}
  </span>
);

export default CopyAnnouncer;
